module.exports = __webpack_public_path__ + "media/images/symbols/facebook-social-089dfc8ad015c2c85d188efe81842431.jpg";